import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RichTextEditorComponent } from 'app/shared/components/rich-text-editor/rich-text-editor.component';

@Component({
    selector: 'formly-field-custom-quill',
    template: `<app-rich-text-editor [formControl]="$any(formControl)" class="block border-0 p-0" [readonly]="!!props.readonly" [formlyAttributes]="field" />`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RichTextEditorComponent, FormsModule, ReactiveFormsModule, FormlyModule]
})
// Extends the Material FieldType (not the core one): this type is registered with
// `wrappers: ['form-field']`, and only the Material base attaches a control to the
// wrapper's <mat-form-field>. <app-rich-text-editor> is not a MatFormFieldControl, so the
// base falls back to acting as the control itself. See MatFormField._control.
export class FieldRichTextType extends FieldType<FormlyFieldConfig> {}
